import * as React from "react";
function SvgUserPlus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M20 25h10M25 20v10"
      />
      <circle
        cx={14}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M9.11 29H3a11 11 0 0118.54-8"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserPlus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
